export const messages = {
  en: {
    accountDetailManage: {
      title: 'Account Details',
      detailId: 'Detail ID',
      transactionId: 'Transaction ID',
      accountName: 'Account Name',
      detailType: 'Detail Type',
      amountPoints: 'Amount/Points',
      transactionTime: 'Transaction Time',
      description: 'Description',
      deposit: 'Deposit',
      depositCancelled: 'Deposit Cancelled',
      withdrawal: 'Withdrawal',
      back: 'Back'
    },
    cancelAccountDetail: {
      title: 'Cancel Deposit',
      accountName: 'Account Name',
      cancelAmount: 'Cancel Amount',
      cancelReason: 'Cancel Reason',
      submit: 'Submit',
      cancel: 'Cancel',
      required: 'Required field'
    }
  },
  zh: {
    accountDetailManage: {
      title: '账户明细',
      detailId: '明细编号',
      transactionId: '交易编号',
      accountName: '账户名称',
      detailType: '明细类型',
      amountPoints: '金额/积分',
      transactionTime: '交易时间',
      description: '说明',
      deposit: '转入',
      depositCancelled: '转入已撤销',
      withdrawal: '转出',
      back: '返回'
    },
    cancelAccountDetail: {
      title: '预存撤销',
      accountName: '账户名称',
      cancelAmount: '撤销金额',
      cancelReason: '撤销原因',
      submit: '提交',
      cancel: '取消',
      required: '必填项'
    }
  }
}